import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoomDetectionHalfautomatisch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 23 22",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(-1,0,0,1,12.312724,21.101692)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Laag-1",
				"serif:id": "Laag 1",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M-9.613,-8.223L-2,-8.223L0,0L-7.613,0L-9.613,-8.223Z",
					style: {
						fill: "none",
						fillRule: "nonzero",
						stroke: "currentColor",
						strokeWidth: "1.5px"
					}
				})
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.718075,0,0,0.677509,9.745309,19.96849)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0,-21.867L7.441,-21.867C9.002,-21.867 10.269,-20.518 10.269,-18.855L10.269,-14.232",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.718075,0,0,0.677509,9.745309,19.96849)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0.66,0L-8.754,0C-10.316,0 -11.582,-1.348 -11.582,-3.012L-11.582,-18.855C-11.582,-20.518 -10.316,-21.867 -8.754,-21.867L-6.088,-21.867L-2.654,-18.432",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		})
	]
});
export default SvgRoomDetectionHalfautomatisch;
